import { Component, OnInit, AfterViewInit, Inject, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { RegistrationService } from "../Service/Registration.Service";
import { SecurityService } from '../../Security/security.service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { ModalComponent } from "../../shared/modeldialog/index";
import { ManadatoryFieldsDataModel, NationalityModel, TitleModel, AreaDataModel, BloodGroups, RelationFields, ReligionDetails, RegistrationDataModel, AlternateType, Gender, ProviderCode } from "../../model/index";
import { ReCaptchaComponent } from 'angular2-recaptcha';
declare var require: any;

@Component({
    selector: 'MentisSoft-Registration',
    template: require('../Template/Registration.template.html'),
    styles: [require('../Template/Registration.css')]
})

export class RegistrationComponent implements AfterViewInit {

    @ViewChild("RegistrationPopup") RegistrationPopup: ModalComponent;
    @ViewChild(ReCaptchaComponent) captcha: ReCaptchaComponent;

    today = new Date();
    registrationDataModel: RegistrationDataModel = new RegistrationDataModel;
    manadatoryFieldsDataModel: ManadatoryFieldsDataModel[] = [];
    TitleModel: TitleModel[] = [];
    NationalityDataModel: NationalityModel[] = [];
    AreaDataModel: AreaDataModel[] = [];
    BloodGroupsList: BloodGroups[] = [];
    RelationFieldsList: RelationFields[] = [];
    ReligionFieldsList: ReligionDetails[] = [];
    AlternateTypeList: AlternateType[] = [];
    ProviderCodeList: ProviderCode[] = [];
    genderList: Gender[] = [];
    mandatoryParams: Object = {};
    IsRequiredTitle: boolean = false;
    IsReqFirstName: boolean = false;
    IsReqMiddleName: boolean = false;
    IsReqLastName: boolean = false;
    IsReqEmployer: boolean = false;
    IsReqOccouption: boolean = false;
    IsReqpassportNo: boolean = false;
    IsReqPassportValidity: boolean = false;
    IsReqAltNO: boolean = false;
    IsReqAltnoValidity: boolean = false;
    IsReqNationality: boolean = false;
    IsReqGender: boolean = false;
    IsReqMobileNo: boolean = false;
    IsReqEmail: boolean = false;
    showGeneral: boolean = false;
    showAddress: boolean = false;
    showPresonal: boolean = false;
    showContact: boolean = false;
    showGeneralClass: string;
    showAddressClass: string;
    showPresonalClass: string;
    showContactClass: string;
    disableNext: boolean = false;
    currentFormName: string = "GeneralForm";
    nextForm: string;
    disableback: boolean = false;
    IsTitleRed: boolean = false;
    IsFirstNameRed: boolean = false;
    LastNameRed: boolean = false;
    AlternateNoRed: boolean = false;
    IsGenderRed: boolean = false;
    IsMobileNoRed: boolean = false;
    MobileNoValid: boolean = false;
    IsEmailRed: boolean = false;
    captchaVerification: boolean;
    registrationId: number = 0;
    IsMiddleNameRed: boolean = false;
    IsAlternateValidityRed: boolean = false;
    IsNationalityRed: boolean = false;
    IsEmployerRed: boolean = false;
    IsOccupationRed: boolean = false;
    IsPassportNoRed: boolean = false;
    IsHouseNoRed: boolean = false;
    IsPassportValidityRed: boolean = false;
    IsAreaRed: boolean = false;
    IsFlatRed: boolean = false;
    IsZipCodeRed: boolean = false;
    IsTownRed: boolean = false;
    IsBloodGroupRed: boolean = false;
    IsMaritalStatusRed: boolean = false;
    IsDobRed: boolean = false;
    IsReligionRed: boolean = false;
    IsFatherHusbandNameRed: boolean = false;
    IsTelephoneRed: boolean = false;
    IsTelephoneValid: boolean = false;
    IsEmergencyContactPersonRed: boolean = false;
    IsRelationRed: boolean = false;
    IsEmergenceContactNoRed: boolean = false;
    IsEmergenceContactNoValid: boolean = false;
    IsNoteRed: boolean = false;
    IsReqHouseNo: boolean = false;
    IsReqArea: boolean = false;
    IsReqFlat: boolean = false;
    IsReqTown: boolean = false;
    IsReqZipCode: boolean = false;
    IsReqBloodGroup: boolean = false;
    IsReqMaritalStatus: boolean = false;
    IsReqDob: boolean = false;
    IsReqReligion: boolean = false;
    IsReqFather: boolean = false;
    IsReqTelephone: boolean = false;
    IsReqContactPerson: boolean = false;
    IsReqRelation: boolean = false;
    IsReqContactNo: boolean = false;
    IsReqNotes: boolean = false;
    IsReqAlternateType: boolean = false;
    AlternateTypeRed: boolean = false;
    BookingType: string = "";
    loading = false;
    code: string = "";
    CaptchaCodeTyped: string = "";
    ValidDate: boolean = true;
    ValidPasValidityDate: boolean = true;
    ValidDobValidityDate: boolean = true;
    InValidEmail: boolean = false;
    IsAlternateNoNumeric: boolean = false;

    AlternateNoForthirty: boolean = false;
    AlternateNolength: string = "";
    IDvalue: string = "";
    CPRNOlength: string = "";
    OtherValue: string = "";
    selectedAltType: string = "";
    HospitalName: string = "";
    ISReligion: boolean = false;

    formNames = [{ name: "GeneralForm", id: 1, idName: "GeneralInformation", Title: "General Information" },
    { name: "AddressForm", id: 2, idName: "Address", Title: "Address" },
    { name: "PersonalForm", id: 3, idName: "PersonalDetails", Title: "Personal Details" },
    { name: "ContactForm", id: 4, idName: "OtherInformation", Title: "Other Information" }];


    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };

    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private _registrationService: RegistrationService, private _titleService: Title) {
        this.loading = true;
        this.LoadTitleInfo();
    };

    assingTabInd(event) {
        event.target.children[0].children[0].children[0].setAttribute('tabIndex', event.target.tabIndex)
        event.target.children[0].children[0].children[1].children[0].setAttribute('tabIndex', event.target.tabIndex)
    }
    onDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            if (dt < this.today && !(dt.toDateString() == this.today.toDateString())) {
                this.ValidDate = false;
            }
            else if (dt > this.today || dt.toDateString() == this.today.toDateString()) {
                this.ValidDate = true;
            }
        }
    }

    onPassportDateChanged(event: IMyDateModel) {
        if (event != undefined) {
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            if (dt < this.today && !(dt.toDateString() == this.today.toDateString())) {
                this.ValidPasValidityDate = false;
            }
            else if (dt > this.today || dt.toDateString() == this.today.toDateString()) {
                this.ValidPasValidityDate = true;
            }
        }
    }

    onDobDateChanged(event: IMyDateModel) {
        if (event != undefined && event.formatted != "") {
            this.registrationDataModel.IsDateEnteredManually = false;
            var dt = new Date(event.date.year, event.date.month - 1, event.date.day);
            if (dt < this.today || dt.toDateString() == this.today.toDateString()) {
                this.ValidDobValidityDate = true;
            }
            else if (dt > this.today) {
                this.ValidDobValidityDate = false;
            }
            this.registrationDataModel.Dob = event.formatted;
        }
    }

    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("Online Pre-Registration");
        this.formSwitch();
        this.captchaCode();
    }

    formSwitch() {
        if (this.currentFormName == "GeneralForm") {
            this.showGeneral = true;
            this.showAddress = false;
            this.showPresonal = false;
            this.showContact = false;
            this.disableNext = true;
            this.disableback = true;
        }

        else if (this.currentFormName == "AddressForm") {
            this.showGeneral = false;
            this.showAddress = true;
            this.showPresonal = false;
            this.showContact = false;
            this.disableNext = true;
            this.disableback = false;
        }

        else if (this.currentFormName == "PersonalForm") {
            this.showGeneral = false;
            this.showAddress = false;
            this.showPresonal = true;
            this.showContact = false;
            this.disableNext = true;
            this.disableback = false;
        }

        else if (this.currentFormName == "ContactForm") {
            this.showGeneral = false;
            this.showAddress = false;
            this.showPresonal = false;
            this.showContact = true;
            this.disableNext = false;
            this.disableback = false;
        }
    }

    formSubmit() {
        if (this.currentFormName == "GeneralForm") {
            this.ValidateGeneralForm();
            this.ValidateNationality();
        }

        if (this.currentFormName == "PersonalForm") {
            this.ValidatePersonalForm();
        }
        if (this.currentFormName == "AddressForm") {
            this.ValidateArea();
        }

        if (this.IsTitleRed != true && this.IsNationalityRed != true && this.IsFirstNameRed != true && this.LastNameRed != true && this.AlternateNoRed != true &&
            this.currentFormName != "AddressForm" && this.currentFormName != "PersonalForm" && this.AlternateTypeRed != true &&
            this.ValidDate != false && this.ValidPasValidityDate != false) {

            if (this.currentFormName == "GeneralForm") {
                this.currentFormName = "AddressForm";
                this.formSwitch();
            }
        }

        else if (this.IsAreaRed != true && this.currentFormName != "GeneralForm" && this.currentFormName != "PersonalForm") {
            if (this.currentFormName == "AddressForm") {
                this.currentFormName = "PersonalForm";
                this.formSwitch();
            }
        }

        else if (this.IsGenderRed != true && this.IsDobRed != true && this.IsMaritalStatusRed != true && this.ValidDobValidityDate != false && this.currentFormName != "GeneralForm" && this.currentFormName != "AddressForm") {
            if (this.currentFormName == "PersonalForm") {
                if (this.registrationDataModel.Dob.length < 10 && this.registrationDataModel.Dob == null) {
                    this.ValidDobValidityDate = false;
                }
                else {
                    this.ValidDobValidityDate = true;
                    this.currentFormName = "ContactForm";
                    this.formSwitch();
                }

            }
        }
    }

    formBack() {
        if (this.currentFormName == "GeneralForm") {
            this.disableback = true;
            this.formSwitch();
        }
        else if (this.currentFormName == "AddressForm") {
            this.currentFormName = "GeneralForm";
            this.disableback = false;
            this.formSwitch();
        }
        else if (this.currentFormName == "PersonalForm") {
            this.currentFormName = "AddressForm";
            this.disableback = false;
            this.formSwitch();
        }
        else if (this.currentFormName == "ContactForm") {
            this.currentFormName = "PersonalForm";
            this.disableback = false;
            this.formSwitch();
        }
    }

    getCurrentTab(item) {
        if (item.name == "GeneralForm") {
            this.currentFormName = "GeneralForm";
            item.name = this.currentFormName;
            this.formSwitch();
        }

        else if (item.name == "AddressForm") {
            this.ValidateGeneralForm();
            this.ValidateNationality();
            if (this.IsNationalityRed == true || this.IsFirstNameRed == true || this.LastNameRed == true || this.AlternateNoRed == true || this.AlternateTypeRed == true) {
                item = this.formNames[0];
                this.currentFormName = "GeneralForm";
                item.name = this.currentFormName;
                this.formSwitch();
            }
            else {
                this.currentFormName = "AddressForm";
                this.formSwitch();
            }
        }

        else if (item.name == "PersonalForm") {
            this.ValidateGeneralForm();
            if (this.IsTitleRed == false && this.IsFirstNameRed == false && this.LastNameRed == false && this.AlternateNoRed == false && this.AlternateTypeRed == false) {
                this.currentFormName = "PersonalForm";
                this.formSwitch();
            }
            else {
                item = this.formNames[0];
                this.currentFormName = "GeneralForm";
                item.name = this.currentFormName;
                this.formSwitch();
            }
        }

        else if (item.name == "ContactForm") {
            this.ValidateGeneralForm();
            this.ValidatePersonalForm();
            if (this.IsTitleRed == true || this.IsFirstNameRed == true || this.LastNameRed == true || this.AlternateNoRed == true && this.AlternateTypeRed == true) {
                item = this.formNames[0];
                this.currentFormName = "GeneralForm";
                item.name = this.currentFormName;
                this.formSwitch();
            }
            else if (this.IsGenderRed == true) {
                item = this.formNames[2];
                this.currentFormName = "PersonalForm";
                item.name = this.currentFormName;
                this.formSwitch();
            }

            else {
                this.currentFormName = "ContactForm";
                this.formSwitch();
            }
        }

    }

    LoadTitleInfo() {
        this._SecurityService.authentication = "TESTAUTH";
        this._registrationService.GetTitle("", this._SecurityService.authentication)
            .subscribe(
            p => {
                this.BookingType = p.BookingType;

                this.AlternateNolength = p.AlternateNolength;
                this.CPRNOlength = p.CPRNOlength;
                this.HospitalName = p.HospitalName;
                this.TitleModel = p.GetTitleList;
                this.genderList = p.GenderList;
                this.NationalityDataModel = p.NationalityFields;
                this.AreaDataModel = p.AreaList;
                this.RelationFieldsList = p.RelationFieldsList;
                this.ReligionFieldsList = p.ReligionFieldsList;
                this.AlternateTypeList = p.AlternateTypeList;
                this.BloodGroupsList = p.BloodGroupsList;
                this.ProviderCodeList = p.ProviderCodeList;
                if (p.ISReligion == "TRUE")
                    this.ISReligion = true;
                else
                    this.ISReligion = false;

                this.manadatoryFieldsDataModel = p.MandatoryFields;
                for (var i = 0; i < p.MandatoryFields.length; i++) {
                    this.mandatoryParams[p.MandatoryFields[i].FieldName.toUpperCase()] = p.MandatoryFields[i].MandatoryFlag;
                }
                this.AssignMandatoryFields();
                this.loading = false;
            });
    }

    AssignMandatoryFields() {

        if (this.mandatoryParams["TITLE"] == true) { this.IsRequiredTitle = true }
        else { this.IsRequiredTitle = false; }

        if (this.mandatoryParams["FIRST NAME"] == true) { this.IsReqFirstName = true }
        else { this.IsReqFirstName = false; }

        if (this.mandatoryParams["LAST NAME"] == true) { this.IsReqLastName = true }
        else { this.IsReqLastName = false; }

        if (this.mandatoryParams["MIDDLE NAME"] == true) { this.IsReqMiddleName = true }
        else { this.IsReqMiddleName = false; }

        if (this.mandatoryParams["ALTERNATE NO."] == true) { this.IsReqAltNO = true }
        else { this.IsReqAltNO = false; }

        if (this.mandatoryParams["ALTERNATE NO. VALIDITY"] == true) { this.IsReqAltnoValidity = true }
        else { this.IsReqAltnoValidity = false; }

        if (this.mandatoryParams["NATIONALITY"] == true) { this.IsReqNationality = true }
        else { this.IsReqNationality = false; }

        if (this.mandatoryParams["EMPLOYER"] == true) { this.IsReqEmployer = true }
        else { this.IsReqEmployer = false; }

        if (this.mandatoryParams["OCCUPATION"] == true) { this.IsReqOccouption = true }
        else { this.IsReqOccouption = false; }

        if (this.mandatoryParams["PASSPORT NO."] == true) { this.IsReqpassportNo = true }
        else { this.IsReqpassportNo = false; }

        if (this.mandatoryParams["PASSPORT VALIDITY DATE"] == true) { this.IsReqPassportValidity = true }
        else { this.IsReqPassportValidity = false; }

        if (this.mandatoryParams["MOBILE NO."] == true) { this.IsReqMobileNo = true }
        else { this.IsReqMobileNo = false; }

        if (this.mandatoryParams["PO BOX"] == true) { this.IsReqHouseNo = true }
        else { this.IsReqHouseNo = false; }

        if (this.mandatoryParams["AREA/ISLAND"] == true) { this.IsReqArea = true }
        else { this.IsReqArea = false; }

        if (this.mandatoryParams["FLAT NUMBER"] == true) { this.IsReqFlat = true }
        else { this.IsReqFlat = false; }

        if (this.mandatoryParams["TOWN"] == true) { this.IsReqTown = true }
        else { this.IsReqTown = false; }

        if (this.mandatoryParams["ZIP CODE"] == true) { this.IsReqTown = true }
        else { this.IsReqTown = false; }

        if (this.mandatoryParams["BLOOD GROUP"] == true) { this.IsReqTown = true }
        else { this.IsReqTown = false; }

        if (this.mandatoryParams["MARITAL STATUS"] == true) { this.IsReqMaritalStatus = true }
        else { this.IsReqMaritalStatus = false; }

        if (this.mandatoryParams["DATE OF BIRTH"] == true) { this.IsReqDob = true }
        else { this.IsReqDob = false; }

        if (this.mandatoryParams["RELIGION"] == true) { this.IsReqReligion = true }
        else { this.IsReqReligion = false; }

        if (this.mandatoryParams["FATHER"] == true) { this.IsReqFather = true }
        else { this.IsReqFather = false; }

        if (this.mandatoryParams["TELEPHONE"] == true) { this.IsReqTelephone = true }
        else { this.IsReqTelephone = false; }

        if (this.mandatoryParams["EMERGENCY CONTACT PERSON"] == true) { this.IsReqContactPerson = true }
        else { this.IsReqContactPerson = false; }

        if (this.mandatoryParams["KIN RELATION"] == true) { this.IsReqRelation = true }
        else { this.IsReqRelation = false; }

        if (this.mandatoryParams["KIN CONTACT NUMBER"] == true) { this.IsReqContactNo = true }
        else { this.IsReqContactNo = false; }

        if (this.mandatoryParams["NOTES"] == true) { this.IsReqNotes = true }
        else { this.IsReqNotes = false; }

        this.IsReqGender = true;
        this.IsReqEmail = true;
        this.IsReqAlternateType = true;
    }

    BackToLogin() {
        this.router.navigate(["/Login"]);
    }
    OnNationalityChange(item) {
        this.registrationDataModel.Nationality = item;
    }
    OnMobileProviderChange(item) {
        this.registrationDataModel.ProviderCode = item;
    }
    OnGenderChange(item) {
        this.registrationDataModel.Gender = item;
    }

    ValidateGeneralForm() {
        if (this.IsRequiredTitle == true) {
            if (this.registrationDataModel.Title == "null" || this.registrationDataModel.Title == "" || this.registrationDataModel.Title == undefined) {
                this.IsTitleRed = true;
            }
            else {
                this.IsTitleRed = false;
            }
        }

        if (this.IsReqFirstName == true) {
            if (this.registrationDataModel.FirstName == null || this.registrationDataModel.FirstName == "" || this.registrationDataModel.FirstName == undefined) {
                this.IsFirstNameRed = true;
            }
            else {
                this.IsFirstNameRed = false;
            }
        }

        if (this.IsReqLastName == true) {
            if (this.registrationDataModel.LastName == null || this.registrationDataModel.LastName == "" || this.registrationDataModel.LastName == undefined) {
                this.LastNameRed = true;
            }
            else {
                this.LastNameRed = false;
            }
        }



        if (this.IsReqAltNO == true && this.registrationDataModel.AlternateNo != undefined) {
            if (this.registrationDataModel.AlternateNo == null || this.registrationDataModel.AlternateNo == "" ||
                this.registrationDataModel.AlternateNo == undefined || this.AlternateNoRed == true) {
                this.AlternateNoRed = true;
                this.AlternateNoForthirty = true;
            }
            else {
                if (this.registrationDataModel.AlternateNo.length == Number(this.AlternateNolength))
                    this.AlternateNoRed = false;
            }
        }

        if (this.IsReqAlternateType == true) {
            if (this.registrationDataModel.AlternateType == "null" || this.registrationDataModel.AlternateType == "" || this.registrationDataModel.AlternateType == undefined) {
                this.AlternateTypeRed = true;
            }
            else {
                this.AlternateTypeRed = false;
            }
        }
    }

    ValidatePersonalForm() {
        this.ValidateDob();
        this.ValidateMaritalStatus();
        if (this.IsReqGender == true) {
            if (this.registrationDataModel.Gender == "null" || this.registrationDataModel.Gender == undefined || this.registrationDataModel.Gender == "") {
                this.IsGenderRed = true;
            }
            else {
                this.IsGenderRed = false;
            }
        }
    }

    keyPress(event: any) {

        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    ValidateForm() {

        if (this.CaptchaCodeTyped != "" || this.CaptchaCodeTyped != null) {
            if (this.code == this.CaptchaCodeTyped) {
                this.captchaVerification = true;
            }
            else {
                this.captchaVerification = false;
            }
        }

        if (this.IsReqMobileNo == true) {
            if (this.registrationDataModel.ProviderCode == "null" || this.registrationDataModel.ProviderCode == undefined || this.registrationDataModel.ProviderCode == "" || this.registrationDataModel.MobileNo == "null" || this.registrationDataModel.MobileNo == undefined || this.registrationDataModel.MobileNo == "") {
                this.IsMobileNoRed = true;
                this.MobileNoValid = false;
            }
            else {
                this.IsMobileNoRed = false;
                if (this.registrationDataModel.MobileNo.toString().length < 8)
                    this.MobileNoValid = true;
                else
                    this.MobileNoValid = false;

            }
        }
        else {
            if (this.registrationDataModel.ProviderCode != "null" && this.registrationDataModel.ProviderCode != undefined && this.registrationDataModel.ProviderCode != "" && this.registrationDataModel.MobileNo != "null" && this.registrationDataModel.MobileNo != undefined && this.registrationDataModel.MobileNo != "") {
                this.IsMobileNoRed = false;

                if (this.registrationDataModel.MobileNo.toString().length < 8)
                    this.MobileNoValid = true;
                else
                    this.MobileNoValid = false;
            }



        }
        this.ValidateEmergencyContactNo();
        this.ValidateTelephoneNo();
        if (this.IsReqEmail == true) {
            if (this.registrationDataModel.Email == "null" || this.registrationDataModel.Email == undefined || this.registrationDataModel.Email == "") {
                this.IsEmailRed = true;
                this.InValidEmail = false;
            }
            else {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var result = re.test(String(this.registrationDataModel.Email).toLowerCase());
                if (result == false) {
                    this.InValidEmail = true;
                }
                else {
                    this.InValidEmail = false;
                }
                this.IsEmailRed = false;
            }
        }

        if (this.captchaVerification == true && this.IsMobileNoRed == false && this.IsEmailRed == false && this.InValidEmail == false && this.MobileNoValid == false) {
            this._registrationService.SaveDetails(this.registrationDataModel)
                .subscribe(
                p => {
                    this.loading = true;
                    if (p != null) {
                        this.registrationId = p;
                        this.RegistrationPopup.open();
                        this.loading = false;
                    }
                    else {
                        this.BookingType = "Error";
                        this.RegistrationPopup.open();
                        this.loading = false;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while validating...");
                }
                );
        }
    }

    ValidateMiddleName() {
        if (this.IsReqMiddleName == true) {
            if (this.registrationDataModel.MiddleName == "null" || this.registrationDataModel.MiddleName == "" || this.registrationDataModel.MiddleName == undefined) {
                this.IsMiddleNameRed = true;
            }
            else {
                this.IsMiddleNameRed = false;
            }
        }
    }

    ValidateAlternateValidity() {
        if (this.IsReqAltnoValidity == true) {
            if (this.registrationDataModel.AlternateValidity == "null" || this.registrationDataModel.AlternateValidity == "" || this.registrationDataModel.AlternateValidity == undefined) {
                this.IsAlternateValidityRed = true;
            }
            else {
                this.IsAlternateValidityRed = false;
            }
        }
    }

    ValidateNationality() {
        if (this.IsReqNationality == true) {
            if (this.registrationDataModel.Nationality == "null" || this.registrationDataModel.Nationality == "" || this.registrationDataModel.Nationality == undefined) {
                this.IsNationalityRed = true;
            }
            else {
                this.IsNationalityRed = false;
            }
        }
    }

    ValidateEmployer() {
        if (this.IsReqEmployer == true) {
            if (this.registrationDataModel.Employer == "null" || this.registrationDataModel.Employer == "" || this.registrationDataModel.Employer == undefined) {
                this.IsEmployerRed = true;
            }
            else {
                this.IsEmployerRed = false;
            }
        }
    }

    ValidateIsOccupationRed() {
        if (this.IsReqOccouption == true) {
            if (this.registrationDataModel.Occupation == "null" || this.registrationDataModel.Occupation == "" || this.registrationDataModel.Occupation == undefined) {
                this.IsOccupationRed = true;
            }
            else {
                this.IsOccupationRed = false;
            }
        }
    }

    ValidatePassportNo() {
        if (this.registrationDataModel.PassportNo == "null" || this.registrationDataModel.PassportNo == "" || this.registrationDataModel.PassportNo == undefined) {
            this.IsPassportNoRed = true;
        }
        else {
            this.IsPassportNoRed = false;
        }
    }

    ValidatePassportValidity() {
        if (this.IsReqPassportValidity == true) {
            if (this.registrationDataModel.PassportValidity == "null" || this.registrationDataModel.PassportValidity == "" || this.registrationDataModel.PassportValidity == undefined) {
                this.IsPassportValidityRed = true;
            }
            else {
                this.IsPassportValidityRed = false;
            }
        }
    }

    ValidateHouseNo() {
        if (this.IsReqHouseNo == true) {
            if (this.registrationDataModel.HouseNo == "null" || this.registrationDataModel.HouseNo == "" || this.registrationDataModel.HouseNo == undefined) {
                this.IsHouseNoRed = true;
            }
            else {
                this.IsHouseNoRed = false;
            }
        }
    }

    ValidateArea() {
        if (this.IsReqArea == true) {
            if (this.registrationDataModel.Area == "null" || this.registrationDataModel.Area == "" || this.registrationDataModel.Area == undefined) {
                this.IsAreaRed = true;
            }
            else {
                this.IsAreaRed = false;
            }
        }
    }

    ValidateFlat() {
        if (this.IsReqFlat == true) {
            if (this.registrationDataModel.Flat == "null" || this.registrationDataModel.Flat == "" || this.registrationDataModel.Flat == undefined) {
                this.IsFlatRed = true;
            }
            else {
                this.IsFlatRed = false;
            }
        }
    }

    ValidateZipCode() {
        if (this.IsReqZipCode == true) {
            if (this.registrationDataModel.ZipCode == "null" || this.registrationDataModel.ZipCode == "" || this.registrationDataModel.ZipCode == undefined) {
                this.IsZipCodeRed = true;
            }
            else {
                this.IsZipCodeRed = false;
            }
        }
    }

    ValidateTown() {
        if (this.IsReqTown == true) {
            if (this.registrationDataModel.Town == "null" || this.registrationDataModel.Town == "" || this.registrationDataModel.Town == undefined) {
                this.IsTownRed = true;
            }
            else {
                this.IsTownRed = false;
            }
        }
    }

    ValidateBloodGroup() {
        if (this.IsReqBloodGroup == true) {
            if (this.registrationDataModel.BloodGroup == "null" || this.registrationDataModel.BloodGroup == "" || this.registrationDataModel.BloodGroup == undefined) {
                this.IsBloodGroupRed = true;
            }
            else {
                this.IsBloodGroupRed = false;
            }
        }
    }

    ValidateMaritalStatus() {
        if (this.IsReqMaritalStatus == true) {
            if (this.registrationDataModel.MaritalStatus == "null" || this.registrationDataModel.MaritalStatus == "" || this.registrationDataModel.MaritalStatus == undefined) {
                this.IsMaritalStatusRed = true;
            }
            else {
                this.IsMaritalStatusRed = false;
            }
        }
    }

    ValidateDob() {
        if (this.IsReqDob == true) {
            if ((this.registrationDataModel.Dob == null || this.registrationDataModel.Dob == "" || this.registrationDataModel.Dob == undefined) && !this.registrationDataModel.IsDateEnteredManually) {
                this.IsDobRed = true;
            }
            else {
                this.IsDobRed = false;
            }
        }
    }

    ValidateReligion() {
        if (this.IsReqReligion == true) {
            if (this.registrationDataModel.Religion == "null" || this.registrationDataModel.Religion == "" || this.registrationDataModel.Religion == undefined) {
                this.IsReligionRed = true;
            }
            else {
                this.IsReligionRed = false;
            }
        }
    }

    ValidateFatherHusbandName() {
        if (this.IsReqFather == true) {
            if (this.registrationDataModel.FatherHusbandName == "null" || this.registrationDataModel.FatherHusbandName == "" || this.registrationDataModel.FatherHusbandName == undefined) {
                this.IsFatherHusbandNameRed = true;
            }
            else {
                this.IsFatherHusbandNameRed = false;
            }
        }
    }

    ValidateTelephoneNo() {
        if (this.IsReqTelephone == true) {
            if (this.registrationDataModel.Telephone == "null" || this.registrationDataModel.Telephone == "" || this.registrationDataModel.Telephone == undefined) {
                this.IsTelephoneRed = true;
                this.IsTelephoneValid = false
            }
            else {
                this.IsTelephoneRed = false;
                if (this.registrationDataModel.Telephone.toString().length < 20)
                    this.IsTelephoneValid = true;
                else
                    this.IsTelephoneValid = false;
            }

        }
        else {
            if (this.registrationDataModel.Telephone != "null" && this.registrationDataModel.Telephone != undefined && this.registrationDataModel.Telephone != "") {
                this.IsTelephoneRed = false;
                if (this.registrationDataModel.Telephone.toString().length < 8)
                    this.IsTelephoneValid = true;
                else
                    this.IsTelephoneValid = false;
            }
        }
    }

    ValidateEmergencyContactPerson() {
        if (this.IsReqContactPerson == true) {
            if (this.registrationDataModel.EmergencyContactPerson == "null" || this.registrationDataModel.EmergencyContactPerson == "" || this.registrationDataModel.EmergencyContactPerson == undefined) {
                this.IsEmergencyContactPersonRed = true;
            }
            else {
                this.IsEmergencyContactPersonRed = false;
            }
        }
    }

    ValidateRelation() {
        if (this.IsReqRelation == true) {
            if (this.registrationDataModel.Relation == "null" || this.registrationDataModel.Relation == "" || this.registrationDataModel.Relation == undefined) {
                this.IsRelationRed = true;
            }
            else {
                this.IsRelationRed = false;
            }
        }
    }

    ValidateEmergencyContactNo() {
        if (this.IsReqContactNo == true) {
            if (this.registrationDataModel.EmergenceContactNo == "null" || this.registrationDataModel.EmergenceContactNo == "" || this.registrationDataModel.EmergenceContactNo == undefined) {
                this.IsEmergenceContactNoRed = true;
                this.IsEmergenceContactNoValid = false;
            }
            else {
                this.IsEmergenceContactNoRed = false;
                if (this.registrationDataModel.EmergenceContactNo.length < 8)
                    this.IsEmergenceContactNoValid = true;
                else
                    this.IsEmergenceContactNoValid = false;
            }
        }
        else {
            if (this.registrationDataModel.EmergenceContactNo != "null" && this.registrationDataModel.EmergenceContactNo != undefined && this.registrationDataModel.EmergenceContactNo != "") {
                this.IsEmergenceContactNoRed = false;
                if (this.registrationDataModel.EmergenceContactNo.length < 8)
                    this.IsEmergenceContactNoValid = true;
                else
                    this.IsEmergenceContactNoValid = false;
            }
        }
    }

    ValidateNotes() {
        if (this.IsReqNotes == true) {
            if (this.registrationDataModel.Note == "null" || this.registrationDataModel.Note == "" || this.registrationDataModel.Note == undefined) {
                this.IsNoteRed = true;
            }
            else {
                this.IsNoteRed = false;
            }
        }
    }

    captchaCode() {
        var Numb1, Numb2, Numb3, Numb4, Code;
        Numb1 = (Math.ceil(Math.random() * 10) - 1).toString();
        Numb2 = (Math.ceil(Math.random() * 10) - 1).toString();
        Numb3 = (Math.ceil(Math.random() * 10) - 1).toString();
        Numb4 = (Math.ceil(Math.random() * 10) - 1).toString();
        this.code = Numb1 + Numb2 + Numb3 + Numb4;
    }


    onAlternateTypeChange(event) {
        this.selectedAltType = event;
        this.registrationDataModel.AlternateNo = "";
        if (this.HospitalName == "JNH") {
            if (event == "9" || event == "14") {
                this.IsAlternateNoNumeric = false;
                this.OtherValue = this.AlternateNolength;
            }
            else {
                this.IsAlternateNoNumeric = true;
                this.IDvalue = this.CPRNOlength;
            }
        }
        else if (this.HospitalName == "IBN") {
            if (event == "6") {
                this.IsAlternateNoNumeric = false;
                this.OtherValue = this.AlternateNolength;
            }
            else {
                this.IsAlternateNoNumeric = true;
                this.IDvalue = this.CPRNOlength;
            }
        }
        else {
            if (event == "8" || event == "10") {
                this.IsAlternateNoNumeric = true;
            }
            else {
                this.IsAlternateNoNumeric = false;
            }
        }
    }

    onTitlechange(event) {
        if (event == "000001") {
            this.registrationDataModel.Gender = "M";
        }

        else if (event == "000003" || event == "000002") {
            this.registrationDataModel.Gender = "F";
        }

        else {
            this.registrationDataModel.Gender = "";
        }
    }

    NumberTextChange(event) {
        if (event.target.value.length > 20 || event.target.value.length != 20) {
            this.IsTelephoneValid = true;
        }
        else {
            this.IsTelephoneValid = false;
        }
    }
    AlternateNoChange(event) {

        if (this.selectedAltType == "9" || this.selectedAltType == "14" && this.HospitalName == "JNH") {
            if (event.target.value.length < 1) {
                this.AlternateNoForthirty = true;
            }
            else {
                this.AlternateNoRed = false;
                this.AlternateNoForthirty = false;
            }
        }
        else if (this.selectedAltType == "6" && this.HospitalName == "IBN") {
            if (event.target.value.length < 1) {
                this.AlternateNoForthirty = true;
            }
            else {
                this.AlternateNoRed = false;

                this.AlternateNoForthirty = false;
            }

        }
        else {
            if (event.target.value.length > Number(this.CPRNOlength) || event.target.value.length != Number(this.CPRNOlength)) {
                this.AlternateNoRed = true;

            }
            else {
                this.AlternateNoRed = false;
            }
        }

    }
    mobileNoChanged(event) {
        if (event.target.value.length < 8) {
            this.MobileNoValid = true;

        }
        else {
            this.MobileNoValid = false;
        }
    }

    telephoneNoChanged(event) {
        if (event.target.value.length < 8) {
            this.IsTelephoneValid = true;

        }
        else {
            this.IsTelephoneValid = false;
        }
    }
    onKey(event) {
        if (event.inputType != "deleteContentBackward") {
            if (event.target.value.length == 2 || event.target.value.length == 5) {
                event.target.value = event.target.value + "/";
            }

            else if (event.target.value.length == 10 || event.target.value.length > 10) {
                event.preventDefault();
                event.target.value = event.target.value.substr(0, 10);
                var y = event.target.value.substr(0, 2);
                var y1 = +y;
                var x = event.target.value.substr(3, 2);
                var x1 = +x;
                var z = event.target.value.substr(6, 4);
                var z1 = +z;
                if (x1 > 12 || z1 > this.today.getFullYear() || y1 > 31) {
                    this.ValidDobValidityDate = false;
                }
                if (x1 == 2) {
                    this.ValidDobValidityDate = (y1 <= 28 ? true : false);
                }
            }
        }
        this.registrationDataModel.IsDateEnteredManually = true;
    }

    MobileNoChange(event) {
        if (event.target.value.length > 8 || event.target.value.length != 8) {
            this.MobileNoValid = true;
        }
        else {
            this.MobileNoValid = false;
        }
    }
    private handleError(error: any) {
        console.log("error : " + error);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Register/Component/Registration.Component.ts